import { combineReducers } from 'redux';

import { reducer as allReducer } from './all';
import { reducer as appliedReducer } from './applied';
import { reducer as categoriesReducer } from './categories';
import { reducer as categorizedReducer } from './categorized';
import { reducer as detailsReducer } from './details';
import { reducer as favouriteReducer } from './favourite';
import { reducer as applyReducer } from './apply';
import { reducer as followedCouponsReducer } from './followedCoupons';

export default combineReducers({
  all: allReducer,
  applied: appliedReducer,
  categories: categoriesReducer,
  categorized: categorizedReducer,
  details: detailsReducer,
  favourite: favouriteReducer,
  apply: applyReducer,
  followedCoupons: followedCouponsReducer,
});
